import { combineReducers } from '@reduxjs/toolkit';
import { userAbilitiesReducer } from './reducers/user-abilities-reducer';
import userstore from './reducers/user-store';
import type { IUserState } from './interfaces';

export default combineReducers<IUserState>({
  userAbilitiesReducer,
  userstore,
});
